import React, {useCallback} from 'react'
import {Box, Button, Text} from "@chakra-ui/react";
import './BarAction.css'
import docs from "../utils/docs.json";
import {useHistory} from "react-router-dom";
import legal_docs from "../utils/legal_docs.json";

const BarAction = (props) => {

    let history = useHistory ();

    const create = useCallback(() => {
        console.log("Stiamo per navigare in lab"+history)
        history.push ('/lab');
    }, [history]);
    const edit = useCallback(() => {
        history.push ('/edit/poi');
    }, [history]);
    const trash = useCallback(() => {
        history.push ('/poi/trash');
    }, [history]);
    const itinerary = useCallback(() => {
        history.push ('/itinerary');
    },[history]);



    return(
        <Box className="barAction">
            <Box className="barContainerAction">
                <Button
                    onClick={create}
                    variant="solid"
                    size="md"
                    fontWeight={"600"}
                    boxShadow={" rgb(38, 57, 77) 0px 2px 3px 1px"}
                >
                    Crea Poi
                </Button>

                <Button
                    onClick={edit}
                    variant="solid"
                    size="md"
                    fontWeight={"600"}
                    boxShadow={" rgb(38, 57, 77) 0px 2px 3px 1px"}
                >
                    Modifica Poi
                </Button>

                <Button
                    onClick={itinerary}
                    variant="solid"
                    size="md"
                    fontWeight={"600"}
                    boxShadow={" rgb(38, 57, 77) 0px 2px 3px 1px"}
                >
                    Crea itinerario
                </Button>
                <Button
                    onClick={itinerary}
                    disabled
                    variant="solid"
                    size="md"
                    fontWeight={"600"}
                    boxShadow={" rgb(38, 57, 77) 0px 2px 3px 1px"}
                >
                    Modifica itinerario
                </Button>
                <Button
                    onClick={trash}
                    variant="solid"
                    size="md"
                    fontWeight={"600"}
                    boxShadow={" rgb(38, 57, 77) 0px 2px 3px 1px"}
                >
                    Cestino
                </Button>

                <a className='alert_documentation' href={docs?.full.docs} target="_blank" rel="noreferrer">
                    <p>Apri la docs!</p>
                </a>

                <a className='alert_documentation' href={legal_docs.GDPR.v1} target="_blank" rel="noreferrer">
                    <p>GDPR</p>
                </a>
            </Box>
        </Box>
    );
}

export default BarAction
